const INTEGRATIONS_NEW_USER_SIGNUP_KEY = 'frameio-integrations-new-user-signup';

/**
 * The integrations "new-user" status is resolved on the Unauthenticated
 * page, before sign-in completes. Sign-in completion is a real
 * `window.location.assign` navigation (not a client-side route change), so
 * session storage is used as the mechanism to indicate the new user status.
 */
export const setIntegrationsNewUserSignup = () => {
  // eslint-disable-next-line no-storage/no-browser-storage
  sessionStorage.setItem(INTEGRATIONS_NEW_USER_SIGNUP_KEY, 'true');
};

export const getIntegrationsNewUserSignup = (): boolean => {
  // eslint-disable-next-line no-storage/no-browser-storage
  const value = sessionStorage.getItem(INTEGRATIONS_NEW_USER_SIGNUP_KEY);
  // eslint-disable-next-line no-storage/no-browser-storage
  sessionStorage.removeItem(INTEGRATIONS_NEW_USER_SIGNUP_KEY);
  return value === 'true';
};
